<script setup>
import { computed } from 'vue';
import CategoryNavItem from './CategoryNavItem.vue';
import { isCategoryActive, isExactActive } from '../helpers/column-left-data.js';

const props = defineProps({
  category: { type: Object, required: true },
  active: { type: Object, required: true },
  depth: { type: Number, default: 0 }
});

const children = computed(() =>
  Array.isArray(props.category.children) ? props.category.children : []
);

const hasChildren = computed(() => children.value.length > 0);

const isOpen = computed(
  () => hasChildren.value && isCategoryActive(props.category, props.active)
);

const linkClass = computed(() => ({
  'vsb-col-nav__link--active': isExactActive(props.category, props.active),
  'vsb-col-nav__link--parent-active': isOpen.value && !isExactActive(props.category, props.active)
}));
</script>

<template>
  <li class="vsb-col-nav__item" :class="`vsb-col-nav__item--depth-${depth}`">
    <a :href="category.href" class="vsb-col-nav__link" :class="linkClass">
      {{ category.name }}
    </a>
    <ul v-if="hasChildren && isOpen" class="vsb-col-nav__children">
      <CategoryNavItem
        v-for="child in children"
        :key="child.categoryId"
        :category="child"
        :active="active"
        :depth="depth + 1"
      />
    </ul>
  </li>
</template>

<style scoped>
.vsb-col-nav__item {
  list-style: none;
  margin: 0;
  padding: 0;
}

.vsb-col-nav__link {
  display: block;
  padding: 0.45rem 0.65rem;
  font-size: 0.9rem;
  color: var(--vsb-col-link, #334155);
  text-decoration: none;
  border-radius: 6px;
  line-height: 1.35;
}

.vsb-col-nav__link:hover {
  background: #f8fafc;
  color: var(--vsb-col-link-active, #0b3d91);
}

.vsb-col-nav__link--active {
  background: var(--vsb-col-link-active-bg, #eef4fb);
  color: var(--vsb-col-link-active, #0b3d91);
  font-weight: 700;
}

.vsb-col-nav__link--parent-active {
  color: var(--vsb-col-link-active, #0b3d91);
  font-weight: 600;
}

.vsb-col-nav__children {
  list-style: none;
  margin: 0.15rem 0 0.35rem 0.5rem;
  padding: 0 0 0 0.65rem;
  border-left: 2px solid var(--vsb-col-child-border, #e8ecf0);
}

.vsb-col-nav__item--depth-1 .vsb-col-nav__link {
  font-size: 0.86rem;
}

.vsb-col-nav__item--depth-2 .vsb-col-nav__link {
  font-size: 0.84rem;
  padding-left: 0.5rem;
}
</style>
